import {
  DELETE_OBJECTION,
  DELETE_OBJECTION_FAILURE,
  DELETE_OBJECTION_SUCCESS,
  GET_OBJECTIONS,
  GET_OBJECTIONS_FAILURE,
  GET_OBJECTIONS_SUCCESS,
  GET_SINGLE_OBJECTION,
  GET_SINGLE_OBJECTION_FAILURE,
  GET_SINGLE_OBJECTION_SUCCESS,
} from "./actionTypes";

export const getObjections = () => {
  return {
    type: GET_OBJECTIONS,
  };
};

export const getObjectionsSuccess = (country) => {
  return {
    type: GET_OBJECTIONS_SUCCESS,
    payload: country,
  };
};

export const getObjectionsFailure = (error) => {
  return {
    type: GET_OBJECTIONS_FAILURE,
    payload: error,
  };
};

export const getSingleObjection = (id) => {
  return {
    type: GET_SINGLE_OBJECTION,
    payload: id,
  };
};

export const getSingleObjectionSuccess = (country) => {
  return {
    type: GET_SINGLE_OBJECTION_SUCCESS,
    payload: country,
  };
};

export const getSingleObjectionFailure = (error) => {
  return {
    type: GET_SINGLE_OBJECTION_FAILURE,
    payload: error,
  };
};

export const deleteObjection = (id) => {
  return {
    type: DELETE_OBJECTION,
    payload: id,
  };
};

export const deleteObjectionSuccess = (id) => {
  return {
    type: DELETE_OBJECTION_SUCCESS,
    payload: id,
  };
};

export const deleteObjectionFailure = (error) => {
  return {
    type: DELETE_OBJECTION_FAILURE,
    payload: error,
  };
};
